import { GatsbyImage, getImage, StaticImage, withArtDirection, IGatsbyImageData } from 'gatsby-plugin-image';
import esgMobile from '../../assets/img/esg-chart-mobile.png';
import esgDesktop from '../../assets/img/esg-chart-desktop.png';
import { useStaticQuery, graphql } from "gatsby";
import React from 'react';
import { processLink } from '../../shared/processLink';
import './MediaReport.scss';
import { MediaReportButton } from './MediaReportButton/MediaReportButton';

export interface MediaReportInputs {
    ctaLink?: { uri: string; title: string };
    fieldReportLink?: { uri: string; title: string };
    learnMoreLink?: { uri: string; title: string };
    image?: any;
    title: string;
    textContent?: string;
}

export const MediaReport = ({ inputs }: { inputs: MediaReportInputs }) => {
    let linkSource = inputs.learnMoreLink;
    if (inputs.ctaLink) {
        linkSource = inputs.ctaLink;
    } else if (inputs.fieldReportLink) {
        linkSource = inputs.fieldReportLink;
    }

    const gImage = getImage(
        inputs.image?.relationships.field_media_image?.localFile
    );

    return (
        <section className="kite-container paragraph__media_report">
            <h2 className="typestack-title-3">{inputs.title}</h2>
            {inputs.textContent && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: inputs.textContent,
                    }}
                ></div>
            )}
            {gImage && (
                <a href={processLink(linkSource.uri, false)}>
                    <picture>
                        <source media="(min-width: 600px)" srcSet={esgDesktop} />
                        <img src={esgMobile} alt="ESG Chart" />
                    </picture>
                </a>
            )}
            {linkSource.title && (
                <MediaReportButton
                    title={linkSource.title}
                    url={processLink(linkSource.uri, false)}
                    thin={!!inputs.ctaLink}
                />
            )}
        </section>
    );
};
